module.exports = __webpack_public_path__ + "static/img/phone_frame.98a46d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone_frame.png
// module id = 1142
// module chunks = 0